import { z } from 'zod';

/** Where a part sits in the candidate → quoted → manufactured funnel. */
export const PART_STATUSES = [
  'candidate',
  'analysis',
  'assessment_failed',
  'rfq_sent',
  'quoted',
  'in_progress',
  'completed',
] as const;

export type PartStatus = (typeof PART_STATUSES)[number];

export const partStatusSchema = z.enum(PART_STATUSES);
